import React, { ReactElement, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { updateFormErrors } from 'redux/registration/actions'
import { idpValidateUserId, postIdpProfile } from 'redux/idp/actions'
import { RootState } from 'redux/store'
import { getCurrentLanguageFromStorage, validate } from 'helpers'
import { TermsOfService } from 'const/idp'
import InlineError from 'ui/atoms/InlineError/IdP'
import Form from 'ui/organisms/Registration/Form'
import { useLocation } from 'react-router-dom'
import { LocationState } from 'types/locationState'

interface RegistrationFormProps {
  returnTo?: string
}

const RegistrationForm = ({
  returnTo
}: RegistrationFormProps): ReactElement => {
  const { registration, ebillStatus } = useSelector(
    (state: RootState) => ({
      registration: state.registration,
      ebillStatus: state.idp.completeResponse?.ebillStatus
    }),
    shallowEqual
  )
  const [ebillSelection, setEbillSelection] = useState<string>(
    ebillStatus ? '0' : '1'
  )
  const { registerForm, formErrors } = registration || {}
  const { registrationUID } = registerForm || {}
  const dispatch = useDispatch()
  const { state } = useLocation<LocationState>()
  const { queryParams = '' } = state || {}
  const language = getCurrentLanguageFromStorage()

  const handleSubmit = (): void => {
    dispatch(postIdpProfile(ebillSelection))
  }

  const handleOnBlur = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target
    if (name === 'registrationUID' && registrationUID) {
      dispatch(idpValidateUserId())
    }

    dispatch(updateFormErrors({ ...formErrors, [name]: validate(name, value) }))
  }

  return (
    <Form
      returnTo={`${returnTo}${queryParams}`}
      eConsentLink={TermsOfService[language]}
      ebillStatus={ebillStatus}
      ebillSelection={ebillSelection}
      hasEmailOffers={false}
      handleEbillSelection={setEbillSelection}
      handleOnBlur={handleOnBlur}
      handleOnSubmit={handleSubmit}
      errorWrapper={<InlineError centerAlign />}
    />
  )
}

export default RegistrationForm
